import { render, staticRenderFns } from "./VacantBedDetail.vue?vue&type=template&id=e65af350&"
import script from "./VacantBedDetail.vue?vue&type=script&lang=js&"
export * from "./VacantBedDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports